
import { useOrgSettings } from "@/services";
import { IBusinessLine } from "@/types";
import { computed, defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const linesMenu = ref();
    const orgSettings = useOrgSettings();
    const businessLinesOptions = computed(() => orgSettings.businessLines);
    const selectedLine = computed(() => orgSettings.selectedBusinessLine);
    function closeMenu() {
      linesMenu.value?.hide(true);
    }

    function selectBusinessLine(line: IBusinessLine) {
      orgSettings.setSelectedBusinessLine(line);
      closeMenu();
    }

    return {
      linesMenu,
      businessLinesOptions,
      selectedLine,
      selectBusinessLine,
    };
  },
});
